import { render, staticRenderFns } from "./TemperatureModal.vue?vue&type=template&id=47fa201a&scoped=true&"
import script from "./TemperatureModal.vue?vue&type=script&lang=js&"
export * from "./TemperatureModal.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureModal.vue?vue&type=style&index=0&id=47fa201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa201a",
  null
  
)

export default component.exports